import { PlayerDownloadComponent } from './player-download/player-download.component';
import { PlayerComponent } from './player/player.component';
import { ClaimPageComponent } from './claim-page/claim-page.component';
import { PingTestComponent } from './core.module/components/ping-test/ping-test.component';
import { NotFoundComponent } from './core.module/components/not-found.component/not-found.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// App fall-back and test routes..
const appRoutes: Routes = [
  {
    path: 'landing',
    loadChildren: './landing-page.module/landing-page.module#LandingPageModule'
  }, {
    path: 'auth',
    loadChildren: './auth.module/auth.module#AuthModule'
  }, {
    path: 'main',
    loadChildren: './backend-main.module/backend-main.module#BackendMainModule'
  }, {
    path: 'ping',
    component: PingTestComponent,
  }, {
    path: 'claim',
    component: ClaimPageComponent,
  }, {
    path: 'redeem',
    component: ClaimPageComponent,
  }, {
    path: 'coupon',
    component: ClaimPageComponent,
  }, {
    path: 'player',
    loadChildren: './player/player.module#PlayerModule'
  }, {
    path: 'download',
    component: PlayerDownloadComponent
  }, {
    path: 'km',
    loadChildren: './kalipso-message/kalipso-message.module#KalipsoMessageModule'
  }, {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: '**',
    component: NotFoundComponent
  }
];


@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts